/**
 * START: isJSON
 * 
 * @param {string|object} str
 * @returns {bool}
 */
function isJSON(str) {
    try {
        return (JSON.parse(str) && !!str);
    } catch (e) {
        return false;
    }
}
/**
 * END: isJSON
 */

/**
 * START: Focus Trap for Modal Accessibility
 * 
 * @param {HTMLElement} modal - The modal element to trap focus within
 * @returns {object} - Object with enable/disable methods
 */
function createFocusTrap(modal) {
    let isActive = false;
    let focusableElements = [];
    let firstFocusable = null;
    let lastFocusable = null;
    let previouslyFocused = null;

    const focusableSelectors = [
        'button:not([disabled]):not([tabindex="-1"])',
        '[href]:not([tabindex="-1"])',
        'input:not([disabled]):not([type="hidden"]):not([tabindex="-1"])',
        'select:not([disabled]):not([tabindex="-1"])',
        'textarea:not([disabled]):not([tabindex="-1"])',
        '[tabindex]:not([tabindex="-1"])',
        '[contenteditable]:not([tabindex="-1"])'
    ].join(', ');

    function updateFocusableElements() {
        focusableElements = Array.from(modal.querySelectorAll(focusableSelectors))
            .filter(el => el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement);
        firstFocusable = focusableElements[0];
        lastFocusable = focusableElements[focusableElements.length - 1];
    }

    function handleKeyDown(e) {
        if (!isActive) return;

        if (e.key === 'Tab') {
            updateFocusableElements();
            
            if (focusableElements.length === 0) {
                e.preventDefault();
                return;
            }

            if (e.shiftKey) {
                // Shift + Tab
                if (document.activeElement === firstFocusable) {
                    e.preventDefault();
                    lastFocusable.focus();
                }
            } else {
                // Tab
                if (document.activeElement === lastFocusable) {
                    e.preventDefault();
                    firstFocusable.focus();
                }
            }
        } else if (e.key === 'Escape') {
            // Close modal on Escape key
            const closeButton = modal.querySelector('[data-dismiss="modal"], .close');
            if (closeButton) {
                closeButton.click();
            }
        }
    }

    return {
        enable: function() {
            if (isActive) return;
            
            isActive = true;
            previouslyFocused = document.activeElement;
            
            updateFocusableElements();
            
            // Focus the first focusable element or the modal itself
            if (firstFocusable) {
                firstFocusable.focus();
            } else {
                modal.focus();
            }
            
            document.addEventListener('keydown', handleKeyDown);
        },
        
        disable: function() {
            if (!isActive) return;
            
            isActive = false;
            document.removeEventListener('keydown', handleKeyDown);
            
            // Return focus to previously focused element
            if (previouslyFocused && previouslyFocused.focus) {
                previouslyFocused.focus();
            }
        }
    };
}

/**
 * Initialize focus traps for all modals on the page
 */
function initializeModalFocusTraps() {
    const modals = document.querySelectorAll('.modal[role="dialog"]');
    
    modals.forEach(modal => {
        const focusTrap = createFocusTrap(modal);
        
        // Enable focus trap when modal is shown
        $(modal).on('shown.bs.modal', function() {
            focusTrap.enable();
        });
        
        // Disable focus trap when modal is hidden
        $(modal).on('hidden.bs.modal', function() {
            focusTrap.disable();
        });
    });
}

// Initialize focus traps when DOM is ready
$(document).ready(function() {
    initializeModalFocusTraps();
});

/**
 * END: Focus Trap for Modal Accessibility
 */

/** START: LOGGER */
/**
 * Leg message placeholder
 * 
 * @type String
 */
let logMessage = '';
/**
 * Leg type placeholder
 * 
 * @type String
 */
let logType = '';

/**
 * StackTrace extender, post the errors to the file
 * 
 * @param {array} stackframes
 * @returns {void}
 */
const logPost = (stackframes) => {
    fetch('/api/logger/js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify({
        log: logMessage,
        type: logType,
        stack: JSON.stringify(stackframes),
    })
    })
    .then(response => response.json())
    .catch(error => console.error('Error logging:', error));
};
/**
 * START: Log Error
 * 
 * @param {object} error - containing error name and message
 * @param {bool} explicit - if the error is explicity
 * @returns {void}
 */
function logError(error, explicit) {
    logMessage = '[' + (explicit ? 'EXPLICIT' : 'INEXPLICIT') + '] ' + error.name + ': ' + error.message;
    logType = (explicit ? 'warning' : 'error');
    StackTrace.fromError(error).then(logPost);
}
/**
 * END: logJsError
 */

/**
 * START: Append arrow to the subnavigations
 */
function appendArrow() {
    var spritePath = $('#nav').data('sprite-path') || '/assets/sprites/1.0.2/icons.svg';
    var arrowSvg = '<svg class="svg-icon" role="presentation" aria-hidden="true" width="42" height="28">'
        + '<use class="arrow-open" href="' + spritePath + '#icon-subNavArrow"></use>'
        + '<use class="arrow-close" href="' + spritePath + '#icon-subNavArrowClose" style="display:none"></use>'
        + '</svg>';
    $('#nav ul li').has('ul').prepend('<div class="subnavArrow">' + arrowSvg + '</div>');
}
/**
 * END: appendArrow
 */

/**
 * START: Filter active status in object and .shop-by-link
 * @type object th
 */
function filterActive(th) {
    if (!th.hasClass('active')) {
        $('.shop-by-link').removeClass('active');
        th.addClass('active');
    } else {
        th.removeClass('active');
    }
}
/**
 * END: filterActive
 */

/**
 * START: validate email
 * 
 * @param {string} email
 * @returns {Boolean}
 */
function validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
/**
 * END: validateEmail
 */

/**
 * START: Counter plign
 * Set data-target to the textarea you want to limit chars and data-max with
 * the no. of max characters
 */
function charsCounter() {
    document.querySelectorAll('.charsCounter').forEach(function(counterElement) {
        const maxCharsLimit = counterElement.getAttribute('data-max');
        const target = counterElement.getAttribute('data-target');
        counterElement.textContent = maxCharsLimit;

        // on init when something is already filled in the field
        const targetElement = document.getElementById(target);
        if (targetElement) {
            const text = targetElement.value;
            const remaining = charsCounterRemaining(text, maxCharsLimit);
            counterElement.textContent = remaining;
        }

        // Event handler function
        const handleInputEvent = function() {
            const text = this.value;
            const remaining = charsCounterRemaining(text, maxCharsLimit);
            if (text.length && remaining === 0) {
                this.value = text.substring(0, maxCharsLimit);
            }
            counterElement.textContent = remaining;
        };

        // on key up, in the message text area
        targetElement.addEventListener('keyup', handleInputEvent);
        targetElement.addEventListener('blur', handleInputEvent);

        // on key down, in the message text area
        targetElement.addEventListener('keydown', function() {
            const text = this.value;
            const remaining = charsCounterRemaining(text, maxCharsLimit);
            counterElement.textContent = remaining;
        });
    });
}




/** 
 * END: Counter plign
 */

/**
 * Chars counter remaining limit.
 * 
 * @param {string} text - input value
 * @param {int} maxCharsLimit - max limit
 * @returns {Number} - remaning chars limit
 */
function charsCounterRemaining(text, maxCharsLimit) {
    let remaining = maxCharsLimit - text.length;
    if (remaining < 1) {
        remaining = 0;
    }

    return remaining;
}

/**
 * Moda/Popup generator.
 * 
 * Instead of adding HTML content, we can dynamically create modals / popups.
 * With this approach the HTML content of the site is reduced.
 * 
 * @param {string} id - identificator for HTML tag
 * @param {string} title - string to show in h4 title tag
 * @param {string} body - HTML content to display in modal body
 * @param {string} footer - HTML content to display in modal footer
 * @param {string} size - modal size (modal-lg, modal-sm)
 * @param {string} modalClass - modal additional class
 * @return {void}
 * 
 */
function modal(id, title, body, footer, size, modalClass) {
    let modal = document.getElementById(id);

    // Check if modal wrapper exists; if not, create and append to the body
    if (!modal) {
        const wrapperTpl = document.createElement('div');
        wrapperTpl.classList.add('modal', 'fade');

        if (modalClass) {
            wrapperTpl.classList.add(modalClass);
        }

        wrapperTpl.setAttribute('id', id);
        wrapperTpl.setAttribute('tabindex', '-1');
        wrapperTpl.setAttribute('role', 'dialog');

        document.body.appendChild(wrapperTpl);
        modal = document.getElementById(id);
    }

    modal.innerHTML = '';

    // Prepare default template
    const dialogTpl = document.createElement('div');
    dialogTpl.classList.add('modal-dialog');
    dialogTpl.setAttribute('role', 'document');

    if (size) {
        dialogTpl.classList.add(size);
    }

    const contentTpl = document.createElement('div');
    contentTpl.classList.add('modal-content');

    const headerTpl = document.createElement('div');
    headerTpl.classList.add('modal-header');

    const buttonTpl = document.createElement('button');
    buttonTpl.classList.add('close');
    buttonTpl.type = 'button';
    buttonTpl.setAttribute('data-dismiss', 'modal');
    buttonTpl.setAttribute('aria-label', 'Close');

    const closeTpl = document.createElement('span');
    closeTpl.setAttribute('aria-hidden', 'true');
    closeTpl.innerHTML = '&times;';

    buttonTpl.appendChild(closeTpl);
    headerTpl.appendChild(buttonTpl);

    if (title) {
        const titleTpl = document.createElement('h4');
        titleTpl.classList.add('modal-title');
        titleTpl.innerHTML = title;
        headerTpl.appendChild(titleTpl);
    }

    contentTpl.appendChild(headerTpl);

    if (body) {
        const bodyTpl = document.createElement('div');
        bodyTpl.classList.add('modal-body');
        bodyTpl.innerHTML = body;
        contentTpl.appendChild(bodyTpl);
    }

    if (footer) {
        const footerTpl = document.createElement('div');
        footerTpl.classList.add('modal-footer');
        contentTpl.appendChild(footerTpl);
    }

    dialogTpl.appendChild(contentTpl);
    modal.appendChild(dialogTpl);
}


/**
 * Slide step from parent to target
 * 
 * @param {string} parent - parent step that we want to collapse
 * @param {string} target - target step that we want to show
 * @param {int} duration - animation time
 * @param {bool} scroll - indicator if we need to scroll to the target view
 * @returns {void}
 */
function slideStep(parent, target, duration = 500, scroll) {
    slideUp(parent, duration)
        .then(
            () => slideDown(target, duration, scroll),
            () => slideDown(parent, duration, scroll)
        );
}

/**
 * Slide element up
 * 
 * @param {string} target - target that we want to show
 * @param {int} duration - animation time
 * @returns {Promise}
 */
function slideUp(target, duration = 500) {
    return new Promise((resolve, reject) => {
        if (!target) {
            reject('element does not exist');
            return;
        }

        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = `${duration}ms`;
        target.style.boxSizing = 'border-box';
        target.style.height = `${target.offsetHeight}px`;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;

        setTimeout(() => {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            resolve('done');
        }, duration);
    });
}


/**
 * Slide element down
 * 
 * @param {string} target - target that we want to collapse
 * @param {int} duration - animation time
 * @param {bool} scroll - indicator if we need to scroll to the target view
 * @returns {Promise}
 */
function slideDown(target, duration = 500, scroll) {
    return new Promise((resolve, reject) => {
        if (!target) {
            reject('element does not exist');
            return;
        }

        target.style.removeProperty('display');
        let display = window.getComputedStyle(target).display;
        if (display === 'none') {
            display = 'block';
        }
        target.style.display = display;

        const height = target.offsetHeight;

        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = `${duration}ms`;

        target.style.height = `${height}px`;

        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');

        setTimeout(() => {
            target.style.removeProperty('height');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');

            if (scroll) {
                target.scrollIntoView({ behavior: 'smooth' });
            }

            resolve('done');
        }, duration);
    });
}

/**
 * Add Event, funtion to replicate jQuery document on event listener.
 * 
 * @param {object} parent - object that we want to listen
 * @param {string} evt - event type like 'click'
 * @param {string} selector - id, tag, class we want to start the handler function on event
 * @param {object} handler - function that we want to execute after event
 * @returns {void}
 */
function addEvent(parent, evt, selector, handler) {
    parent.addEventListener(evt, function (event) {
       if (event.target.matches(`${selector}, ${selector} *`)) {
            handler.apply(event.target.closest(selector), arguments);
        }
    }, false);
}

// Polyfill fix for matches.
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

// Polyfill fix for closest.
if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        let el = this;

        do {
            if (Element.prototype.matches.call(el, s))
                return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
// Polyfill fix for trim.
if (!String.prototype.trim) {
    String.prototype.trim = function () {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}

/**
 * Helper function to initialize selectpicker.
 *
 * @param {string} elemId - optional id for selectpicker
 * @returns {void}
 */
function initSelectpicker(elemId = '.selectpicker') {
    /**
     * Floating picker, internal helper function.
     *
     * @param {HTMLElement} el - current processed node
     */
    const floatingPicker = (el) => {
        const id = $(el).attr('id');
        if (id === 'delivery_time') return;

        const formGroup = $(el).parent().parent();

        if (el.value) {
            if (formGroup.hasClass('empty')) {
                formGroup.removeClass('empty');
            }
        } else {
            if (!formGroup.hasClass('empty')) {
                formGroup.addClass('empty');
            }
        }
    };

    if (!$(elemId).length) return;
    $(elemId).selectpicker();

    $(elemId).on('loaded.bs.select', () => {
        $('.bootstrap-select').removeClass('chk-select');
    });

    if ($(window).width() >= 768) {
        $(elemId).on('loaded.bs.select', function () {
            const parent = $(this).parent();
            const select = $(this).closest('select');

            parent.attr('data-original-title', select.attr('data-original-title'));
            parent.attr('data-content', select.attr('data-content'));

            initPopover();
        });

        $(elemId).on('show.bs.select', function () {
            $(this).parent().popover('show');
        });

        $(elemId).on('hide.bs.select', function () {
            $(this).parent().popover('hide');
        });
    }

    $(elemId).on('change', function () {
        floatingPicker(this);
    });

    $(elemId).on('refreshed.bs.select', function () {
        floatingPicker(this);
    });
}

/**
 * Helper function to initialize BS popover.
 * 
 * @returns {void}
 */
function initPopover() {
    const getPlacement = () => ($(window).width() < 768 ? 'top' : 'right');

    $('[data-toggle="popover"]').popover({
        trigger: 'focus',
        html: true,
        placement: getPlacement
    });
    $('.bootstrap-select').popover({
        trigger: 'manual',
        html: true,
        placement: getPlacement
    });
}

/**
 * Infinity load button
 *
 * @param {object} e - event handler
 * @returns {void}
 */
function infinityLoadMore(e) {
    e.preventDefault();

    const btn = this;
    const hideButton = () => btn.classList.add('hidden');

    const toLoad = btn.getAttribute('data-load');
    const target = btn.getAttribute('data-target');
    const elem = document.querySelector(target);

    if (!elem) {
        return hideButton();
    }

    const hiddenItems = elem.querySelectorAll('.d-none');
    if (!hiddenItems.length) {
        return hideButton();
    }

    let i = 1;
    hiddenItems.forEach((item) => {
        if (toLoad === 'all' || i <= toLoad) {
            slideDown(item, 200);
            item.classList.remove('d-none');
        }
        i++;
    });

    if (toLoad === 'all') {
        return hideButton();
    }
}


/**
 * @param object date Javascript date object
 * @returns {string}
 */
function dateToYMD(date) {
    let d = date.getDate();
    let m = date.getMonth() + 1;
    let y = date.getFullYear();
    return '' + y + '-' + (m <= 9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
}

/**
 * @param string date yyyy-mm-dd format
 * @returns {string} m/d/Y
 */
function ymdToMdy(date) {
    const parts = date.split('-');
    return '' + parseInt(parts[1]) + '/' + parseInt(parts[2]) + '/' + parts[0];
}

/**
 * @param string date yyyy-mm-dd format
 * @returns {string} m/d
 */
function ymdToMd(date) {
    const parts = date.split('-');
    return '' + parseInt(parts[1]) + '/' + parseInt(parts[2]);
}

/** 
 * Get JSON data from HTML data tag attribute.
 * 
 * @param {string} id - The ID of the HTML tag
 * @param {string} attrData - The data- attribute tag
 * @returns {Array|Object} - parsed data
 */
function getJsonData(id, attrData)
{
    let data = $(id).attr(attrData);
    try {
        if (data && isJSON(data)) {
            data = JSON.parse(data);
        }
    } catch (e) {
        if (e instanceof SyntaxError) {
            logError(e, true);
        } else {
            logError(e, false);
        }
    }
    return data;
}

/**
 * Parse string date to Y-m-d from selected date.
 * 
 * @param {String} date - jQuery selected date
 * @returns {String} - paresed Y-m-d date
 */
function parseDateToYmd(date) {

    let regexDate = /(\d{1,2}-\d{1,2}-\d{4})/gm;
    let res = date.match(regexDate);
    if (res) {
        let dateParts = date.split('-');
        date = dateParts[2] + '-' + dateParts[0] + '-' + dateParts[1];
    }
    return date;
}

/**
 * Wrapper for fbq function.
 *
 * @param {String} event - event name
 * @param {Object} data - data passed to FB
 * @param {Object} additionalData - additional data passed to FB e.g. eventID
 *
 * @returns {Voids}
 */
function fbTrack(event, data, additionalData)
{
    if (typeof fbq === 'undefined') {
        return;
    }
    if (additionalData) {
        fbq('track', event, data, additionalData);
        return;
    }
    fbq('track', event, data);
}

/**
 * Send custom gtag event.
 *
 * @param {String} event - name of the event
 * @param {Object} data - event data
 * @param {String} sendTo - the tag ID
 *
 * @returns {Void}
 */
function gTagEvent(event, data, sendTo)
{
    if (typeof gtag === 'undefined') {
        return;
    }
    if (!data.send_to || sendTo) {
        data.send_to = 'AW-980990295';
    }
    gtag('event', event, data);
}

/**
 * Get refresh CSRF token for the next request (if server sends back a new one)
 *
 * @param {String} csrf - csrf JSON object
 *
 * @returns {Void}
 */
function getRefreshCsrfToken(csrf)
{
    if (csrf) {
        $("input[name='csrf_avas']").val(csrf);
    }
}

/**
 * Initialize keyboard navigation for secondary category carousel
 * Supports Arrow Left/Right, Home, and End keys
 */
$(document).ready(function() {
    // Secondary category carousel keyboard navigation
    $(document).on('keydown', '.display-area[role="group"]', function(e) {
        const carousel = $(this);
        const prevBtn = carousel.find('button.previous');
        const nextBtn = carousel.find('button.next');
        
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            prevBtn.click();
            prevBtn.focus();
        } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            nextBtn.click();
            nextBtn.focus();
        }
    });
    
    // Main banner carousel keyboard navigation
    $(document).on('keydown', '.carousel.carouselHero', function(e) {
        const carousel = $(this);
        
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            carousel.carousel('prev');
        } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            carousel.carousel('next');
        } else if (e.key === 'Home') {
            e.preventDefault();
            carousel.carousel(0);
        } else if (e.key === 'End') {
            e.preventDefault();
            const itemCount = carousel.find('.item').length;
            carousel.carousel(itemCount - 1);
        }
    });
});